/**
 * Checks if each objects key has a defined value.
 * null/""/NaN/undefined means no value is assigned to the key
 * Empty object is considered as a defined value
 */
export const objectKeysHasVal = (object: { [k: string]: any }): boolean => {
  if (Object.keys(object).length == 0) return false;

  for (const key in object) {
    const value = object[key];
    switch (value) {
      case null:
      case undefined:
      case "":
        return false;
    }

    switch (true) {
      case typeof value === "number" && isNaN(value):
        return false;
    }
  }

  return true;
};
